import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AdaFormConfigService {
  /** When 1 or '1', ADA Form tab and main-flow step are shown. When 0, hidden. */
  payrollIdentifier: number | string = 0;
  payrollAccountNumber: number | string = '';
} 
